import React from "react";
import Films from "../../components/Films/Films";

const Popular = () => {
  return <Films type="popular" />;
};

export default Popular;
